import {VisaFormConfig} from './forms';

export const canMultipleCountries: string[] = [];

export interface Visa {}

export const VISA_FORM_CONFIG: VisaFormConfig = {};
